import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AuthenticatedRoute from "components/AuthenticatedRoute";
import PageNotFound from "components/PageNotFound";
import {
  CREATE_PACKAGE_SCRIPT_ID,
  CREATE_PRODUCT_OFFERINGS_SCRIPT_ID,
  UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID,
  UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID,
  UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID,
  UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID,
} from "constants/constants";
import routes from "constants/routes";
import Login from "containers/Login/Login";
import PackageDetails from "containers/PackageDetails/PackageDetails";
import CreatePackageVersion from "containers/CreatePackageVersion/CreatePackageVersion";
import UploadsSection from "containers/Uploads/UploadsSection";
import CouponsList from "containers/Coupons/CouponsList";
import CreateCoupon from "containers/Coupons/CreateCoupon";
import EditCoupon from "containers/Coupons/EditCoupon";
import ViewCoupon from "containers/Coupons/ViewCoupon";
import PackagesSection from "containers/Packages/PackagesSection";
import DashboardRouteLayout from "shared/DashboardLayout/DashboardRouteLayout";

const uploadsPathWithScript = (scriptId) =>
  `${routes.uploads.root}?scriptId=${scriptId}`;

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to={routes.login.root} />} />
    <Route path={routes.login.root} element={<Login />} />

    <Route element={<AuthenticatedRoute />}>
      <Route element={<DashboardRouteLayout />}>
        <Route
          path={routes.homePage.homePage}
          element={<Navigate to={routes.coupons.list} replace />}
        />
        <Route path={routes.packages.root} element={<PackagesSection />} />
        <Route path={routes.uploads.root} element={<UploadsSection />} />
        <Route path={routes.coupons.list} element={<CouponsList />} />
        <Route path={routes.coupons.create} element={<CreateCoupon />} />
        <Route path="/coupons/:id/edit" element={<EditCoupon />} />
        <Route path="/coupons/:id" element={<ViewCoupon />} />
        <Route
          path={routes.packageDetails.packageDetails}
          element={<PackageDetails />}
        />
        <Route
          path={routes.createPackageVersion.createPackageVersion}
          element={<CreatePackageVersion />}
        />
        <Route
          path="/createPackage"
          element={
            <Navigate to={uploadsPathWithScript(CREATE_PACKAGE_SCRIPT_ID)} replace />
          }
        />
        <Route
          path="/createProductOfferings"
          element={
            <Navigate
              to={uploadsPathWithScript(CREATE_PRODUCT_OFFERINGS_SCRIPT_ID)}
              replace
            />
          }
        />
        <Route
          path="/uploadFeatureOfferings"
          element={
            <Navigate
              to={uploadsPathWithScript(UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID)}
              replace
            />
          }
        />
        <Route
          path="/uploadPackageSchedule"
          element={
            <Navigate
              to={uploadsPathWithScript(UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID)}
              replace
            />
          }
        />
        <Route
          path="/updatePackageSchedule"
          element={
            <Navigate
              to={uploadsPathWithScript(UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID)}
              replace
            />
          }
        />
        <Route
          path="/uploadOrUpdatePackagePaymentHead"
          element={
            <Navigate
              to={uploadsPathWithScript(UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID)}
              replace
            />
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Route>
  </Routes>
);

export default AppRoutes;
